import {UI} from "../../../../stem-core/src/ui/UIBase";

import {styleRuleInherit} from "stem-core/src/ui/Style";
import {styleRule} from "stem-core/src/decorators/Style";

import {registerStyle} from "stem-core/src/ui/style/Theme";
import {Messages} from "../../../Messages";
import {TosMessage} from "../../../website/unauthenticated/components/TosMessage";
import {PoweredByBlink} from "../../PoweredByBlink";
import {isSmallScreen} from "../../../UtilsLib";
import {AccountLookup} from "./AccountLookup";
import {BasePanelPage, BasePanelPageStyle} from "blinkpay/panel/pages/panels/BasePanelPage";
import {AuthSection} from "../../pages/panels/AuthenticationPanel";
import {iFrameMerchantService} from "../../../services/IframeMerchantService";
import {TNR_ALIAS} from "../../../../blink-sdk/Constants";


class CDSAuthenticationPanelStyle extends BasePanelPageStyle {
    @styleRuleInherit
    panelPage = {
        color: this.themeProps.MERCHANT_TEXT_SECONDARY_COLOR,
    };

    @styleRuleInherit
    panelPagePopup = {
        padding: "0 18 0 0 important",
        marginBottom: 18,
    };

    @styleRule
    authHomeDonation = this.themeProps.AUTH_HOME_DONATION;

    @styleRule
    authContainer = {
        display: "flex",
        flexDirection: () => isSmallScreen() ? "column" : "row",
        marginBottom: -4,
    };

    @styleRule
    authColumn = {
        flex: 1,
        ":first-child": {
            marginRight: () => isSmallScreen() ? 0 : 36,
        },
        ":last-child": {
            marginLeft: () => isSmallScreen() ? 0 : 36,
        },
    };

    @styleRule
    authCDSDescription = {
        textAlign: "center",
        marginBottom: 32,
    };

    @styleRule
    authHomeTitle = this.themeProps.PANEL_AUTH_PANEL_TITLE;

    @styleRule
    socialButtons = {
        width: 282,
        textAlign: "center",
        margin: "0 auto 18px",
    };

    @styleRule
    authHomeNavigate = {
        textAlign: "center",
        marginBottom: () => isSmallScreen() ? 12 : 18,
    };

    @styleRule
    link = {
        color: this.themeProps.MERCHANT_LINK,
        textTransform: "lowercase",
        cursor: "pointer",
    };

    @styleRule
    lineSeparator = {
        marginBottom: 18,
    };

    @styleRule
    smallScreenSeparator = {
        display: () => isSmallScreen() ? "block" : "none",
        marginTop: -6,
        marginBottom: 18,
    };

    @styleRule
    bottomSection = {
        marginTop: 6,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
    };

    @styleRule
    verticalLine = {
        width: 1,
        background: "#E3E3E3",
        marginBottom: 14,
    };

    @styleRule
    authHomeTos = {
        marginBottom: -18,
    }
}

@registerStyle(CDSAuthenticationPanelStyle)
export class CDSAuthenticationPanel extends BasePanelPage {
    widthValue = 1070;

    getTopSection() {
        const {styleSheet} = this;

        return [
            <div className={styleSheet.authContainer}>
                <div className={styleSheet.authColumn}>
                    <AuthSection showFooterSection={false}/>
                </div>
                <div className={styleSheet.verticalLine}></div>
                <div className={styleSheet.authColumn}>
                    <div className={styleSheet.authHomeTitle}>{Messages.lookUpPrintMagazineTitle}</div>
                    <div className={styleSheet.authCDSDescription}>{Messages.lookUpPrintMagazineDescription}</div>
                    <AccountLookup/>
                </div>
            </div>
        ];
    }

    getBottomSection() {
        const {styleSheet} = this;
        const extraTosMessageOptions = {};
        if (iFrameMerchantService.isMerchant(TNR_ALIAS)) {
            extraTosMessageOptions.termsLink = "https://newrepublic.com/pages/terms-and-conditions";
            extraTosMessageOptions.policyLink = "https://newrepublic.com/pages/privacy";
        }
        return [
            <div className={styleSheet.bottomSection}>
                <div className={styleSheet.authHomeTos}>{Messages.tosPreMessage}</div>
                <TosMessage className={styleSheet.tos} showBorder={false} {...extraTosMessageOptions} />
            </div>,
            <PoweredByBlink/>
        ]
    }

    render() {
        return [
            this.getTopSection(),
            this.getBottomSection(),
        ];
    }
}
